module.exports = __webpack_public_path__ + "src/img/tv.d0c219bf.svg";